<div class="custom-card-container mb-4">
    <div class="custom-card-title">
        <ng-container *ngIf="address">{{ 'admin.sites.address.editAddress' | translate }}</ng-container>
        <ng-container *ngIf="!address">{{ 'admin.sites.address.createAddress' | translate }}</ng-container>
    </div>
    <div class="custom-card-content">
        <form [formGroup]="addressForm">
            <div class="row">
                <div class="col-md-6">
                    <div class="title">{{ 'admin.sites.address.title' | translate }}</div>
                    <app-auto-complete [prePopulatedValue]="addressForm.controls.description.value" (setAddress)="getAddress($event)" (sendInput)="setFormName($event)" adressTypes="addressTypes"></app-auto-complete>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <div class="title">{{ 'admin.sites.address.addressLine' | translate }} 1</div>
                        <input class="form-control" [placeholder]="'admin.sites.address.addressLine' | translate" [appCountryRtl]="siteCountry" formControlName="line1" />
                    </div>
                    <div class="form-group">
                        <div class="title">{{ 'admin.sites.address.addressLine' | translate }} 2</div>
                        <input class="form-control" [placeholder]="'admin.sites.address.addressLine' | translate" [appCountryRtl]="siteCountry" formControlName="line2" />
                    </div>
                    <div class="form-group">
                        <div class="title">{{ 'admin.sites.address.addressLine' | translate }} 3</div>
                        <input class="form-control" [placeholder]="'admin.sites.address.addressLine' | translate" [appCountryRtl]="siteCountry" formControlName="line3" />
                    </div>
                    <div class="form-group">
                        <div class="title">{{ 'admin.sites.address.addressLine' | translate }} 4</div>
                        <input class="form-control" [placeholder]="'admin.sites.address.addressLine' | translate" [appCountryRtl]="siteCountry" formControlName="line4" />
                    </div>
                    <div class="form-group">
                        <div class="title">{{ 'admin.sites.address.addressLine' | translate }} 5</div>
                        <input class="form-control" [placeholder]="'admin.sites.address.addressLine' | translate" [appCountryRtl]="siteCountry" formControlName="line5" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <div class="title">{{ 'admin.sites.address.country' | translate }}</div>
                        <app-alert *ngIf="countryAlert" [alertSettings]="countryAlert"></app-alert>
                        <div *ngIf="loadingCountries" class="inline-flex mt-1">
                            <div class="loader-inline"></div><div class="loader-text">{{ 'shared.loading' | translate }}</div>
                        </div>
                        <select *ngIf="!loadingCountries && !countryAlert" class="form-control" [appCountryRtl]="siteCountry" formControlName="country" [compareWith]="compare">
                            <option *ngFor="let country of countries" [ngValue]="country">
                                {{country.name}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group">
                        <div class="title">{{ 'admin.sites.address.city' | translate }}</div>
                        <input class="form-control" [placeholder]="'admin.sites.address.city' | translate" [appCountryRtl]="siteCountry" formControlName="town" />
                    </div>
                    <div class="form-group">
                        <div class="title">{{ 'admin.sites.address.postCode' | translate }}</div>
                        <input class="form-control" [placeholder]="'admin.sites.address.postCode' | translate" [appCountryRtl]="siteCountry" formControlName="postcode" />
                    </div>
                    <div class="form-group">
                        <div class="title">{{ 'admin.sites.address.countryStateProvince' | translate }}</div>
                        <input class="form-control" [placeholder]="'admin.sites.address.countryStateProvince' | translate" [appCountryRtl]="siteCountry" formControlName="province" />
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>